<template>
 <div class="foot">
   <div class="footLeft">
     <img style="width:181px;" src="../assets/image/logo2.png" alt="">
   </div>
   <a href="https://play.google.com/store/apps/details?id=credit.prestamos.personale.cash.efectivo" target="_blank" class="playBtn"><img src="@/assets/image/playBtn.png" alt=""></a>
 </div>
  <!-- <div class="footPage">
    <div class="lastPage">
      <div class="mainContent">
        <div class="title">Contáctenos</div>
        <div class="content">
          <div class="item">
            <img src="@/assets/image/ico_1.png" alt="">
            <p class="item-title">Atención de cliente：</p>
            <p class="item-subtitle">5544407595</p>
          </div>
          <div class="item">
            <img src="@/assets/image/ico_2.png" alt="">
            <p class="item-title">Email：</p>
            <p class="item-subtitle">servicio@superapoyo.com</p>
          </div>
          <div class="item">
            <img src="@/assets/image/ico_3.png" alt="">
            <p class="item-title">Dirección de la oficina：</p>
            <p class="item-subtitle">Lázaro Cárdenas 196 A601 Guerrero 06300 Cuauhtémoc, Ciudad de México,MEXICO</p>
          </div>
          <div class="item">
            <img src="@/assets/image/ico_4.png" alt="">
            <p class="item-title">Tiempo laboral：</p>
            <p class="item-subtitle">Lunes a Domingo 9:00—18:00</p>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import "./scss/foot.scss";

export default {
  name: "footPage",
  data() {
    return {

    }
  },
}
</script>
